module.exports = __webpack_public_path__ + "flyer_background_modern_cafe_052-68c8c75655d7fcad8cc9f3ef081f8d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_modern_cafe_052.jpg
// module id = 1664
// module chunks = 1